import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NotificationsService } from '../../services/notifications.service';
import { UsersService } from 'src/app/features/users/services/users.service';
import { NotificationService } from 'src/app/core/services/notification.service';

@Component({
  selector: 'app-notifications-create',
  templateUrl: './notifications-create.component.html',
  styleUrls: ['./notifications-create.component.scss']
})
export class NotificationsCreateComponent implements OnInit {
  notificationForm: FormGroup;
  recipientType: string = 'all';
  loading: boolean = false;
  users: any[] = []; // Lista de usuarios para selección individual
  filteredUsers: any[] = [];
  selectedUserIds: number[] = [];
  loadingUsers: boolean = false;
  userSearchTerm: string = '';
  
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private notificationsService: NotificationsService,
    private usersService: UsersService,
    private toast: NotificationService
  ) {
    this.notificationForm = this.fb.group({
      title: ['', [Validators.required]],
      message: ['', [Validators.required]],
      notification_type: ['info', [Validators.required]],
      importance: ['media', [Validators.required]],
      recipientType: ['all'],
      role: [''],
      userIds: [[]]
    });
  }

  ngOnInit(): void {
    // Cargar usuarios para selección individual
    this.loadUsers();
  }

  loadUsers(): void {
    this.loadingUsers = true;
    this.usersService.getUsers()
      .subscribe({
        next: (users) => {
          this.users = users;
          this.filteredUsers = users;
          this.loadingUsers = false;
        },
        error: (error) => {
          console.error('Error al cargar usuarios:', error);
          this.loadingUsers = false;
        }
      });
  }

  filterUsers(): void {
    if (!this.userSearchTerm) {
      this.filteredUsers = this.users;
      return;
    }
    
    const term = this.userSearchTerm.toLowerCase();
    this.filteredUsers = this.users.filter(user => 
      user.name.toLowerCase().includes(term) ||
      user.last_name.toLowerCase().includes(term) ||
      user.email.toLowerCase().includes(term)
    );
  }

  toggleUserSelection(userId: number): void {
    const index = this.selectedUserIds.indexOf(userId);
    if (index > -1) {
      this.selectedUserIds.splice(index, 1);
    } else {
      this.selectedUserIds.push(userId);
    }
    this.notificationForm.patchValue({ userIds: this.selectedUserIds });
  }

  isUserSelected(userId: number): boolean {
    return this.selectedUserIds.includes(userId);
  }

  get f() {
    return this.notificationForm.controls;
  }

  onRecipientTypeChange(event: any): void {
    this.recipientType = event.target.value;
    
    // Limpiar campos según el tipo seleccionado
    if (this.recipientType === 'all') {
      this.notificationForm.patchValue({ role: '', userIds: [] });
    } else if (this.recipientType === 'role') {
      this.notificationForm.patchValue({ userIds: [] });
    } else if (this.recipientType === 'individual') {
      this.notificationForm.patchValue({ role: '' });
    }
  }

  submitNotification(): void {
    if (this.notificationForm.invalid) {
      // Marcar formulario como tocado para mostrar validaciones
      Object.keys(this.notificationForm.controls).forEach(key => {
        const control = this.notificationForm.get(key);
        control?.markAsTouched();
      });
      return;
    }

    this.loading = true;
    
    // Preparar datos según el tipo de destinatario
    const notificationData: any = {
      title: this.notificationForm.value.title,
      message: this.notificationForm.value.message,
      notification_type: this.notificationForm.value.notification_type,
      importance: this.notificationForm.value.importance,
      send_to_all: false,
      role_filter: null,
      user_ids: null
    };

    // Configurar destinatarios según el tipo
    if (this.recipientType === 'all') {
      notificationData.send_to_all = true;
    } else if (this.recipientType === 'role') {
      notificationData.role_filter = this.notificationForm.value.role;
    } else if (this.recipientType === 'individual') {
      notificationData.user_ids = this.selectedUserIds;
    }

    // Enviar notificación masiva
    this.notificationsService.createBroadcastNotification(notificationData).subscribe({
      next: (response) => {
        this.toast.success(
          `Notificación enviada exitosamente a ${response.notifications_sent} usuario(s)`,
          'Notificación Enviada'
        );
        this.router.navigate(['/notificaciones']);
      },
      error: (error) => {
        console.error('Error al enviar notificación:', error);
        this.toast.error(
          'Error al enviar la notificación. Por favor intente nuevamente.',
          'Error'
        );
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      }
    });
  }
}
